export default "__VITE_ASSET__4ac310b7__"